import withEditarPasswordSesion from "../../hoc/Docentes/withEditarPasswordSesion";
import EditarPassword from "../../view/components/RegistroUsuarios/DatosSesion/EditarDatosSesion/EditarPassword";

export default withEditarPasswordSesion(EditarPassword);